import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

import { Global } from "../../global";
import { ApiService } from "../../service/apiServices";
import { AuthService } from "../../service/auth/auth.service";

@Component({
  selector: "app-painel-chamada-senha",
  templateUrl: "./painel-chamada-senha.component.html",
  styleUrls: ["./painel-chamada-senha.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PainelChamadaSenhaComponent implements OnInit {
  dados = JSON.parse(localStorage.getItem("dadosPresencaUser"));
  presenca_com_inie = JSON.parse(
    localStorage.getItem("@DigtVentry:presencaUser")
  );
  usuario: any = {};
  presenca: any;

  listaSenhas: any = [];
  listaServicos: any = [];
  servicoSelecionado: any = null;

  constructor(
    public service: ApiService,
    public global: Global,
    private router: Router,
    private authService: AuthService
  ) {
    this.authService.currentUser.subscribe((res) => {
      if (res) {
        this.usuario = res;
      }
    });

    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.presenca = res;
      }
    });

    if (!this.dados) {
      this.authService.logoutUser();
    }
  }

  ngOnInit() {
    this.carregarServicos();
    this.carregarSenhas();
  }

  carregarSenhas() {
    Swal.fire("Favor aguarde");
    Swal.showLoading();

    let url = `ChamadaSenha/Chamada?estabelecimento_id=${this.presenca.estabelecimento_id}`;
    
    if (this.servicoSelecionado) {
      url += `&servico_painel_senha_id=${this.servicoSelecionado}`;
    }

    this.service
      .Get(url)
      .then((res: any) => {
        Swal.close();
        this.listaSenhas = res || [];
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        const mensagem = res.error && res.error.erros && res.error.erros[0] && res.error.erros[0].messagem 
          ? res.error.erros[0].messagem 
          : 'Erro ao carregar senhas';
        Swal.fire("Erro", mensagem, "error");
      });
  }

  carregarServicos() {
    this.service
      .Get(`ServicoPainelSenha?ativo=true&estabelecimento_id=${this.presenca.estabelecimento_id}`)
      .then((res: any) => {
        this.listaServicos = res || [];
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          this.authService.logoutUser();
        }
        console.error('Erro ao carregar serviços:', res);
      });
  }

  chamarProximo(): void {
    if (this.listaSenhas.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        html: "Não há senhas aguardando chamada.",
      });
      return;
    }

    const primeiroItem = this.listaSenhas[0];
    this.chamarSenha(primeiroItem);
  }

  chamarSenha(item: any): void {
    if (!this.presenca || !this.presenca.sala_id || !this.presenca.usuario_id) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        html: "Informações de sala ou usuário não encontradas. Por favor, faça login novamente.",
      });
      return;
    }

    const obj = {
      id: item.id,
      sala_id: this.presenca.sala_id,
      usuario_id: this.presenca.usuario_id,
    };

    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.service
      .Post(`ChamadaSenha/Chamada`, obj)
      .then((res) => {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: "Senha chamada com sucesso!",
          timer: 1500,
          showConfirmButton: false
        });
        this.carregarSenhas();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        const mensagem = res.error && res.error.erros && res.error.erros[0] && res.error.erros[0].messagem 
          ? res.error.erros[0].messagem 
          : 'Erro ao chamar senha';
        Swal.fire("Erro", mensagem, "error");
      });
  }

  atenderSenha(item: any): void {
    if (!this.presenca || !this.presenca.sala_id || !this.presenca.usuario_id) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        html: "Informações de sala ou usuário não encontradas. Por favor, faça login novamente.",
      });
      return;
    }

    const obj = {
      id: item.id,
      sala_id: this.presenca.sala_id,
      usuario_id: this.presenca.usuario_id,
    };

    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.service
      .Post(`ChamadaSenha/Atendimento`, obj)
      .then((res) => {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: "Senha atendida com sucesso!",
          timer: 1500,
          showConfirmButton: false
        });
        this.carregarSenhas();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        const mensagem = res.error && res.error.erros && res.error.erros[0] && res.error.erros[0].messagem 
          ? res.error.erros[0].messagem 
          : 'Erro ao atender senha';
        Swal.fire("Erro", mensagem, "error");
      });
  }

  marcarFalta(item: any): void {
    if (!this.presenca || !this.presenca.sala_id || !this.presenca.usuario_id) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        html: "Informações de sala ou usuário não encontradas. Por favor, faça login novamente.",
      });
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Confirmar Falta",
      html: `Deseja realmente marcar a senha <strong>${item.senha}</strong> como falta?`,
      showCancelButton: true,
      confirmButtonText: "Sim, marcar falta",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ffc107",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) {
        const obj = {
          id: item.id,
          sala_id: this.presenca.sala_id,
          usuario_id: this.presenca.usuario_id,
        };

        Swal.fire("Favor aguarde");
        Swal.showLoading();

        this.service
          .Post(`ChamadaSenha/Falta`, obj)
          .then((res) => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              html: "Falta registrada com sucesso!",
              timer: 1500,
              showConfirmButton: false
            });
            this.carregarSenhas();
          })
          .catch((res) => {
            if (res.status == 401 || res.error.status == 401) {
              Swal.close();
              this.authService.logoutUser();
            }
            Swal.close();
            const mensagem = res.error && res.error.erros && res.error.erros[0] && res.error.erros[0].messagem 
              ? res.error.erros[0].messagem 
              : 'Erro ao registrar falta';
            Swal.fire("Erro", mensagem, "error");
          });
      }
    });
  }

  getCorPrioridade(cor: string): string {
    return cor || "#23238E";
  }
}
